import { useQuery } from 'react-query';
import useAuthApi from '../Utils/Api/useAuthApi';

export default function useUserSession() {
  const authApi = useAuthApi();
  return useQuery('session', () => authApi.getSession());
}
